import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { SelectBoxOption, SelectBoxStore } from '../stores/SelectBoxStore';
import { UIHelper } from '../utils/UIHelper';
import { SelectBoxActions } from '../actions/SelectBoxActions';

interface DesktopSelectProps extends React.Props<DesktopSelect> {
    options: Array<SelectBoxOption>;
    title: string;
    value: string | number | boolean | null;
    id: string | number;
    className?: string;
    disabled?: boolean;
    toggle?: string;
}

interface DesktopSelectState {
    open: boolean;
}

export class DesktopSelect extends BaseComponent<DesktopSelectProps, DesktopSelectState> {
    protected enabled: boolean = true;

    public componentWillMount(): void {
        this.addStoreListener(SelectBoxStore, this.onChange);
        this.setState({
            open: false
        });
    }

    public render(): JSX.Element {
        const currentOption: SelectBoxOption = this.getOption();

        return (
            <div
                className={
                    'input-group' + (this.props.disabled ? ' input-group-disabled' : '') +
                    (this.props.className ? ' ' + this.props.className : '')
                }
                onClick={this.toggle}
                tabIndex={0}
            >
                {this.props.title ? <div className="input-group-label">{this.props.title}</div> : null}
                <div
                    className={'desktop-selectbox' + (this.state.open ? ' opened' : '')}
                >
                    <div className="desktop-selectbox-label">{currentOption.name}</div>
                    {this.dropDown()}
                </div>
            </div>
        );
    }

    protected getOption: () => SelectBoxOption = () => {
        const value: string | number | boolean | null = this.props.value;
        if (value == null) {
            return this.props.options[0];
        }
        for (const option of this.props.options) {
            if (option.value === value) {
                return option;
            }
        }
        return this.props.options[0];
    };

    protected onChange = (): void => {
        if (SelectBoxStore.getState().activeDesktopSelectBox != null) {
            this.setState(jQuery.extend({}, this.state, {open: SelectBoxStore.getState().activeDesktopSelectBox === this.props.id}));
        } else {
            this.setState(jQuery.extend({}, this.state, {open: false}));
        }
    };

    protected click = (option: SelectBoxOption) => (event: React.MouseEvent | React.TouchEvent) => {
        UIHelper.stopEvent(event);
        if (option.callback != null) {
            option.callback();
        }
        this.setState({
            open: false
        });
    };

    protected dropDown = (): JSX.Element | null => {
        if (this.state.open) {
            const currentOption: SelectBoxOption = this.getOption();
            return (
                <div className="desktop-select-options">
                    {this.props.options.map((option: SelectBoxOption) => {
                        const cssClass: Array<string> = ['desktop-select-option'];
                        if (option.className) {
                            cssClass.push(option.className);
                        }
                        if (option === currentOption) {
                            cssClass.push('active');
                        }
                        if (option.disabled) {
                            return (
                                <div className={cssClass.join(' ') + ' desktop-select-option-disabled'} key={option.name}>
                                    <span>{option.name}</span>
                                </div>
                            );
                        }

                        return (
                            <div className={cssClass.join(' ')} onClick={this.click(option)} key={option.name}>
                                <span>{option.name}</span>
                            </div>
                        );
                    })}
                </div>
            );
        }

        return null;
    };

    protected toggle = (): void => {
        if (!this.enabled) {
            return;
        }
        this.enabled = false;
        setTimeout(() => {this.enabled = true; }, 100);
        SelectBoxActions.setActiveSelectBox(this.state.open ? null : this.props.id);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DesktopSelect.tsx